import { createAsyncThunk } from "@reduxjs/toolkit";
import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

import { fetchSpecificListingApi } from "./fetchSpecialListing";
import { fetchListingSlice } from "./fetchListingsforUser";
import { fetchStateListingApi } from "./fetchStateListingThunk";

interface IResponse {
  message: string;
}

interface IParams {
  id: string; // documentId inside allListings
}

interface IRejected {
  message: string;
}

export const deleteListingThunk = createAsyncThunk<
  IResponse,
  IParams,
  { rejectValue: IRejected }
>("listing/delete", async (params, thunkAPI) => {
  try {
    // Reference to the document in allListings collection
    const ref = doc(db, "allListings", params.id);

    // Delete the document
    await deleteDoc(ref);

    // Invalidate cache for global listings

    thunkAPI.dispatch(
      fetchSpecificListingApi.util.invalidateTags([{ type: "allListings" }])
    );
    thunkAPI.dispatch(
      fetchListingSlice.util.invalidateTags([{ type: "allListings" }])
    );

    thunkAPI.dispatch(
      fetchStateListingApi.util.invalidateTags([{ type: "LISTINGS" }])
    );

    return { message: "Listing deleted successfully" };
  } catch (error) {
    console.error("Error deleting listing:", error);
    return thunkAPI.rejectWithValue({
      message: "Something went wrong while deleting the listing"
    });
  }
});
